const px = [12, 14, 16, 18, 20, 24, 30, 36, 42, 64, 80];

const toRem = (px, base = 16) => `${px / base}rem`;

export const fontSizes = px.reduce(
  (o, key) => ({ ...o, [key]: toRem(key) }),
  {}
);
